import { createRouter, createWebHistory } from 'vue-router'
import {useStore} from 'vuex'
import { inject } from 'vue';
import { isLogin } from '@/api/home';

import login from '../views/index/login'
import register from '../views/index/register'
import registerAuth from '../views/index/registerAuth'
import registerWx from '../views/index/registerWx'
import quicklogin from '../views/index/quicklogin'

import appeal from '../views/appeal/index'
import appealAuth from '../views/appeal/auth'
import appealInfo from '../views/appeal/info'
import appealStatus from '../views/appeal/status'

import repwd from '../views/findpwd/index'
import repwdSelect from '../views/findpwd/select'
import repwdMobile from '../views/findpwd/mobile'
import repwdEmail from '../views/findpwd/email'
import repwdQuestion from '../views/findpwd/question'
import repwdReset from '../views/findpwd/reset'

import account from '../views/account/index'
import accountIndex from '../views/account/index'
import accountInfo from '../views/account/info'
import accountPwd from '../views/account/pwd'
import accountMobile from '../views/account/mobile'
import accountEmail from '../views/account/email'
import emailBind from '../views/account/emailBind'
import accountWx from '../views/account/weixin'
import accountPro from '../views/account/protection'
import accountMsg from '../views/account/message'
import accountLog from '../views/account/log'
import accountNotice from '../views/account/notice'
import accountChangeKeFu from '../views/account/changeKeFu'
import accountAds from '../views/account/address'
import unsubscribe from '../views/unsubscribe/index'
import delMessage from '../views/unsubscribe/message'
import delCheck from '../views/unsubscribe/check'

import verify from '../views/verify/index'
import verifySelect from '../views/verify/reselect'
import verifyPerson from '../views/verify/person'
import verifyPersonTab from '../views/verify/persontab'
import verifyBis from '../views/verify/business'
import verifyBisInfo from '../views/verify/businessinfo'
import verifyAudit from '../views/verify/audit'
import verifyCheck from '../views/verify/check'
import verifySus from '../views/verify/success'

import error from '../views/index/404'

const routes = [
	{path: '/',redirect: '/login'},
	{
		path: '/login',
		name: 'login',
		component: login,
		meta: {
			title: '会员登录',
			keepAlive: false
		}
	},
	{
		path: '/register',
		name: 'register',
		component: register,
		meta: {
			title: '会员注册',
			keepAlive: false
		}
	},
	{
		path: '/registerAuth',
		name: 'registerAuth',
		component: registerAuth,
		meta: {
			title: '会员注册',
			keepAlive: false
		}
	},
	{
		path: '/registerWx',
		name: 'registerWx',
		component: registerWx,
		meta: {
			title: '会员注册',
			keepAlive: false
		}
	},
	{
		path: '/quicklogin',
		name: 'quicklogin',
		component: quicklogin,
		meta: {
			title: '账号绑定',
			keepAlive: false
		}
	},
	{
		path: '/repwd',
		children:[
			{path: '/repwd',name: 'repwd',component: repwd},
			{path: '/repwdSelect',name: 'repwdSelect',component: repwdSelect},
			{path: '/repwdMobile',name: 'repwdMobile',component: repwdMobile},
			{path: '/repwdEmail',name: 'repwdEmail',component: repwdEmail},
			{path: '/repwdQuestion',name: 'repwdQuestion',component: repwdQuestion},
			{path: '/repwdReset',name: 'repwdReset',component: repwdReset}
		],
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/appeal',
		children:[
			{path: '/appeal',name: 'appeal',component: appeal},
			{path: '/appealAuth',name: 'appealAuth',component: appealAuth},
			{path: '/appealInfo',name: 'appealInfo',component: appealInfo},
			{path: '/appealStatus',name: 'appealStatus',component: appealStatus}
		],
		meta: {
			keepAlive: false
		}
	},
	{
		path: '/account',
		children:[
			{path: '/account',name: 'account',component: account},
			{
				path: '/account/index',
				children:[
					{path: '/account/index',name: 'accountIndex',component: accountIndex},
					{path: '/account/mobile',name: 'accountMobile',component: accountMobile},
					{path: '/account/email',name: 'accountEmail',component: accountEmail},
					{path: '/account/emailBind',name: 'emailBind',component: emailBind},
					{path: '/account/weixin',name: 'accountWx',component: accountWx},
					{path: '/account/protection',name: 'accountPro',component: accountPro},
					{path: '/account/unsubscribe',name: 'unsubscribe',component: unsubscribe},
					{path: '/account/delMessage',name: 'delMessage',component: delMessage},
					{path: '/account/delCheck',name: 'delCheck',component: delCheck}
				]
			},
			{path: '/account/pwd',name: 'accountPwd',component: accountPwd},
			{path: '/account/info',name: 'accountInfo',component: accountInfo},
			{path: '/account/message',name: 'accountMsg',component: accountMsg},
			{path: '/account/log',name: 'accountLog',component: accountLog},
			{path: '/account/notice',name: 'accountNotice',component: accountNotice},
			{path: '/account/changeKeFu',name: 'accountChangeKeFu',component: accountChangeKeFu},
			{
				path: '/verify',
				children:[
					{path: '/verify',name: 'verify',component: verify},
					{path: '/verify/reselect',name: 'verifySelect',component: verifySelect},
					{path: '/verify/person',name: 'verifyPerson',component: verifyPerson},
					{path: '/verify/persontab',name: 'verifyPersonTab',component: verifyPersonTab},
					{path: '/verify/business',name: 'verifyBis',component: verifyBis},
					{path: '/verify/businessinfo',name: 'verifyBisInfo',component: verifyBisInfo},
					{path: '/verify/audit',name: 'verifyAudit',component: verifyAudit},
					{path: '/verify/check',name: 'verifyCheck',component: verifyCheck},
					{path: '/verify/success',name: 'verifySus',component: verifySus}
				]
			},
			{path: '/account/address',name: 'accountAds',component: accountAds}
		],
		meta: {
			keepAlive: true
		}
	},
	
	{
		path: '/404',
		name: 'error',
		component: error,
		meta: {
			title: '404',
			keepAlive: false
		}
	},
	{path: '/:pathMatch(.*)',redirect: '/404'}
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
	const store = useStore()
	const location = window.location.origin
	const reurl = encodeURIComponent(location + to.href)
	const domain = inject('domain');
	const accountDomain = inject('accountDomain');
	isLogin().then((res) => {
		if(res.code === 200){
			store.commit("setLogin", true)
			store.commit("setUserName", res.data.username)
			if (to.name == 'login') {
				window.location.href = domain+"/user";
			}else{
				next();
			}
		}else{
			if (to.name == 'login' || to.name == 'register' || to.name == 'repwd' || to.name == 'repwdSelect' || to.name == 'repwdMobile' || to.name == 'repwdEmail' || to.name == 'repwdQuestion' || to.name == 'repwdReset' || to.name == 'quicklogin' || to.name == 'appeal' || to.name == 'appealAuth' || to.name == 'appealInfo' || to.name == 'appealStatus') {
				next()
			} else { 
				window.location.href = accountDomain + "/login?reurl=" + reurl;
			}
		}
	})
});


export default router